import css from './App.scss';

const App = props => {
    return <div className={css.root}>Clinical Portal</div>;
};

export default App;
